{
  "maximum": "Najviše",
  "minimum": "Najmanje"
}
